export default __webpack_public_path__ + "static/media/enviro_logo.c050ea70.png";